export const US_LOCATION_COORDINATES = {
  LATITUDE: 41.796630,
  LONGITUDE: -88.011470,
  ZOOM: 3.2
};
